import Gateway from '@/utils/Gateway';

// 按业务获取应用列表
export default function getAppsByBusiness(business) {
    return new Promise((resolve, reject) => {
        Gateway.get('/v1/corp/wework/AppsByBusiness', {
            business
        })
            .then(data => {
                resolve(data);
            })
            .catch(e => {
                reject(e);
            });
    });
}
